import styled from '@emotion/styled';
import { Children } from 'react';

import { BREAKPOINTS } from '@/styles/themes/default';
import { IThemeProps } from '@/styles/themes/types';

const StackItem = styled.section<IThemeProps>`
  &:not(:last-of-type) {
    margin-bottom: 120px;
  }
  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    &:not(:last-of-type) {
      margin-bottom: 160px;
    }
  }
`;

const Wrapper = styled.div<IThemeProps>`
  margin-top: 40px;
  @media (min-width: ${BREAKPOINTS.Tablet.min}px) {
    margin-top: 60px;
  }
`;

export const Stack = ({ children }) => {
  return (
    <Wrapper>
      {Children.map(children, (child) => (
        <StackItem key={child.toString()}>{child}</StackItem>
      ))}
    </Wrapper>
  );
};
